module.exports = __webpack_public_path__ + "img/marker_four_yellow3.eded0d18.png";